module.exports = __webpack_public_path__ + "static/media/locationIcon.3fdfbcec.svg";